<template>
  <div class="account">
    <div class="main-content">
      <div class="account-list-container">
        <div class="section-header text-center mobile-hide">
          <h2>{{ $t('inboundInventory') }}</h2>
        </div>
        <div class="filters-toolbar-wrapper">
          <div class="filters-toolbar__item-child">
            <p>Per Page</p>
            <el-select v-model="limit" v-bind:placeholder="$t('limit')" value="" @change="updateLimit">
              <el-option
                v-for="item in limitOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <table class="responsive-table">
          <thead>
            <tr>
              <th>{{ $t('sku') }}</th>
              <!-- <th>{{ $t('containerNum') }}</th> -->
              <th>{{ $t('customer') }}</th>
              <th>{{ $t('storageIn') }}</th>
              <th>{{ $t('remainingQty') }}</th>
              <th>{{ $t('fulfilledQty') }}</th>
              <th>{{ $t('orderQty') }}</th>
              <th>{{ $t('receivedQty') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in this.$store.state.orders.inboundInventory" data-index="index" :key="index" class="responsive-table__row">
              <td data-label="refnum">{{item.refnum}}</td>
              <!-- <td data-label="container_num">{{item.CartonNum}}</td> -->
              <td data-label="customer">{{item.customer}}</td>
              <td data-label="storage_in">{{item.storage_in}}</td>
              <td data-label="remaining_quantity">{{item.remaining_quantity}}</td>
              <td data-label="fulfilled_quantity">{{item.fulfilled_quantity}}</td>
              <td data-label="Quantity">{{item.Quantity}}</td>
              <td data-label="ReceivedQuantity">{{item.ReceivedQuantity}}</td>
            </tr>
          </tbody>
        </table>
        <pagination
          :totalPages="pages"
          :total="count"
          :currentPage="currentPage"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import pagination from "../../components/pagination";

export default {
  name: "inboundInventory",
  components: {
    pagination,
  },
  data() {
    return {
      path2: this.$t('inboundInventory'),
      currentPage: 1,
      // filter for limit
      limit: '15',
      limitOptions: [
        { value: '15', label: '15' },
        { value: '30', label: '30' },
        { value: '50', label: '50' },
        { value: '100', label: '100'},
      ],
    }
  },
  methods: {
    ...mapActions('orders', ['fetchInboundInventory']),
    updateLimit(value) {
      this.limit = value;
      this.updateFilter();
    },
    updateFilter() {
      const page = this.currentPage || 1;
      let limit = ''
      if (this.limit) {
        limit = this.limit;
      }
      this.$store.dispatch('orders/fetchInboundInventory', [limit, page]);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.updateFilter();
      window.scrollTo(0, 0);
    }
  },
  computed: mapState({
    pages: state => state.orders.inboundInventoryPaginate,
    count: state => state.orders.inboundInventoryCount,
  }),
  mounted() {
    this.$store.dispatch('orders/fetchInboundInventory', [this.limit, 1]);
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/accountList.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/inboundInventory.vue